module.exports = __webpack_public_path__ + "static/img/exam-type.0c86ed55.png";